import React, { forwardRef, memo } from 'react'

const CalendarRoundIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    {...props}>
    <circle
      cx="28"
      cy="28"
      r="26.871"
      fill="#fff"
      stroke="#EEE"
      strokeWidth="2.259"
    />
    <path
      d="M35 20.3H21a.7.7 0 0 0-.7.7v14.7c0 .387.313.7.7.7h14c.387 0 .7-.313.7-.7V21a.7.7 0 0 0-.7-.7Z"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.2 18.9v2.8M23.8 18.9v2.8M20.3 24.5h15.4"
      stroke="#78BE20"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

CalendarRoundIcon.displayName = 'CalendarRoundIcon'

export default memo(CalendarRoundIcon)
